import environment from '@/environment';
import AuthService from '@/services/auth-service';

export async function downloadFile(path: string): Promise<void> {
  const url = new URL(path, environment.serverBaseUrl);
  const headers = new Headers();

  const accessToken = AuthService.getAccessToken();
  if (accessToken) {
    headers.set('ACCESS_TOKEN', accessToken);
  }

  const response = await fetch(url, { headers });
  const disposition = response.headers.get('content-disposition');
  let downloadFilename = '';
  if (disposition) {
    const utf8FilenameMatch = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    const fallbackFilenameMatch = /filename="?([^"]+)"?/i.exec(disposition);
    const match = utf8FilenameMatch ?? fallbackFilenameMatch;
    if (match) {
      downloadFilename = decodeURIComponent(match[1]);
    }
  }

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  if (downloadFilename) {
    anchor.download = downloadFilename;
  }
  anchor.click();
  URL.revokeObjectURL(objectUrl);
}
